import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { ISupplierInventoryImportApi } from "./base/supplierInventoryImportApi";
import { Result, ResultMessage } from "../models/common/resultResponse";
import {
	SupplierInventoryImportRequest,
	LogErrorImportRequest,
	SupplierInventoryImportUploadRequest,
	ImportSaveRequest,
} from "../models/request";
import {
	SupplierInventoryImportResponse,
	LogErrorImportResponse,
	SupplierInventoryImportDataResponse,
	SupplierInventorySaveResponse,
} from "../models/response";
import { TimeoutRequestConfigurationEnum } from "../services/enum/TimeoutRequestConfigurationEnum";
import { PaginationResponse } from "../models/common/paginationResponse";

const baseRoute: string = "SupplierInventoryImport";

export class SupplierInventoryImportApi extends ISupplierInventoryImportApi {
	getSearchGrid(
		request: SupplierInventoryImportRequest,
	): Promise<AxiosResponse<PaginationResponse<SupplierInventoryImportResponse>>> {
		return api.post(`${baseRoute}/getSearchGridSupplierImports`, request);
	}

	uploadImportInventory(
		request: SupplierInventoryImportUploadRequest,
		file: File,
	): Promise<AxiosResponse<Result<SupplierInventoryImportDataResponse>>> {
		const params = new URLSearchParams(request as unknown as Record<string, string>);
		const queryString = `?${params.toString()}`;
		const url = `${baseRoute}/import${queryString}`;

		const formData = new FormData();
		formData.append("fileUpload", file);

		return api.post(url, formData, {
			timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds,
		});
	}

	exportInventory(request: SupplierInventoryImportUploadRequest): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/export`, {
			params: request,
			timeout: TimeoutRequestConfigurationEnum.TenMinutesInMilliseconds,
		});
	}

	getLogError(request: LogErrorImportRequest): Promise<AxiosResponse<Result<LogErrorImportResponse>>> {
		return api.get(`${baseRoute}/getLogFilebase64`, { params: request });
	}

	saveImport(request: ImportSaveRequest): Promise<AxiosResponse<ResultMessage<SupplierInventorySaveResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	downloadImportFile(supplierInventoryImportGuid: string): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/downloadImportFile/${supplierInventoryImportGuid}`);
	}

	cancelImport(supplierInventoryImportGuid: string): Promise<AxiosResponse<Result<boolean>>> {
		return api.delete(`${baseRoute}/cancel/${supplierInventoryImportGuid}`);
	}
}
